import type { OfferResponse } from '~/services/cruises/OfferService';

type Offer = OfferResponse['result'];
type Price = Offer['departures']['of'][number]['prices'][number];

export type LowestPriceByCabinCategories = {
  [cabinCategory: string]: { price: number; currencyCode: string };
};

const getLowestPriceByCabinCategories = (prices: Array<Price>): LowestPriceByCabinCategories => {
  const lowestPriceByCabinCategories = prices.reduce((acc, price) => {
    const priceValue = price.total;
    const cabinCategory = price.cabinCategory;
    if (!acc[cabinCategory] || acc[cabinCategory] > priceValue) {
      acc[cabinCategory] = { price: Math.round(priceValue), currencyCode: price.currencyCode };
    }
    return acc;
  }, {});

  return lowestPriceByCabinCategories;
};

export type Departure = {
  id: string;
  externalId: number;
  departureDate: string;
  lowestPriceByCabinCategories: LowestPriceByCabinCategories;
};

export const getDepartures = (offer: Offer): Array<Departure> => {
  const departures = Object.entries(offer.departures ?? {}).flatMap((item) => item[1]) ?? [];
  return departures.map((departure) => ({
    id: departure.id,
    externalId: departure.externalId,
    departureDate: departure.departureDate,
    lowestPriceByCabinCategories: getLowestPriceByCabinCategories(departure.prices),
  }));
};
